import { Injectable } from '@angular/core';
import { HttpClientService } from '../httpClient/httpClient.service';
import { Observable } from 'rxjs';
import { linkBuilderApi } from '../../constants/link-builder-api';
import { PaginationType } from '../../interfaces/pagination/pagination-type';

@Injectable({
    providedIn: 'root'
})
export class LinkBuilderService {
    constructor(private httpClientService: HttpClientService) { }

    getLinkBuilder(pagination: PaginationType): Observable<any> {
        const url = `${linkBuilderApi.getLinkBuilder}?skip=${pagination.skip}&limit=${pagination.limit}`;
        return this.httpClientService.get(url);
    }

    postLinkBuilder(payload: any): Observable<any> {
        return this.httpClientService.post(
            linkBuilderApi.createLinkBuilder,
            payload
        );
    }

    editLinkBuilder(_id: any, payload: any): Observable<any> {
        return this.httpClientService.put(`${linkBuilderApi.editLinkBuilder}?Id=${_id}`, payload);
    }

    deleteLinkBuilder(_id: any): Observable<any> {
        return this.httpClientService.delete(`${linkBuilderApi.deleteLinkBuilder}?Id=${_id}`);
    }


    getIPWhitelist(pagination: PaginationType, search?: string): Observable<any> {
        let query = '?';
        if (search) {
            query += `${search}`;
        }
        query += `skip=${pagination.skip}&limit=${pagination.limit}`;

        const url = `${linkBuilderApi.getIPWhitelist}${query}`;
        return this.httpClientService.get(url);
    }

    

    getIPSearch(pagination: PaginationType, search?:string): Observable<any> {
        let query = '?';
        if (search) {
            query += `${search}`;
        }
        query += `skip=${pagination.skip}&limit=${pagination.limit}`;

        const url = `${linkBuilderApi.getIPSearch}${query}`;
        return this.httpClientService.get(url);
    }

    // postIpAddress(id: any, payload: any): Observable<any> {
    //     return this.httpClientService.post(
    //         linkBuilderApi.createIpWhiteList,
    //         payload
    //     );
    // }

    postIpAddress(id: any, payload: any): Observable<any> {
        // Send the POST request to the API
        return this.httpClientService.post(
            `${linkBuilderApi.createIpWhiteList}/${id}`,  // Assuming you're passing the ID as part of the URL
            payload  // The data (payload) to be sent in the request body
        );
    }


    verifyTwoFactorCode(payload: any): Observable<any> {
        return this.httpClientService.post(
            linkBuilderApi.authTwofactor,
            payload
        );
    }

    editIpAddress(id: any, ipId: any, payload: any): Observable<any> {
        return this.httpClientService.put(`${linkBuilderApi.editIpAddress}/${id}/${ipId}`, payload);
    }
    
    deleteIpAddress(userId: any, ipId: any): Observable<any> {
        return this.httpClientService.delete(`${linkBuilderApi.deleteIpAddress}/${userId}/${ipId}`);
    }

}
